module.exports = __webpack_public_path__ + "img/ic-topup-active.766a0f76.svg";